// ChangeButton.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import global from '../../../styles/index.module.scss';
import styles from './ChangeButton.module.scss';
import { AlertModal } from '../AlertModal/AlertModal';

interface ChangeButtonProps {
  to?: string;
  category?: string;
  stepNumber?: number;
  alertTrigger?: boolean;
  firstcollectionhandle?: string;
}

export const ChangeButton: React.FC<ChangeButtonProps> = ({ to, category, stepNumber, alertTrigger, firstcollectionhandle }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // const handleClick = () => {
  //   if (to) {
  //     setIsModalOpen(true);
  //   } else {
  //     console.warn('リンクがありません');
  //   }
  // };

  const handleClick = () => {
    if (alertTrigger) {
      setIsModalOpen(true);
    } else if (to) {
      // 現在のURLパラメータを取得
      const currentParams = new URLSearchParams(window.location.search);
      
      // toのURLに既存のパラメータがあるかチェック
      const [basePath, existingParams] = to.split('?');
      const urlParams = new URLSearchParams(existingParams || '');
      
      // 現在のパラメータを新しいURLパラメータにマージ（既存パラメータを優先）
      currentParams.forEach((value, key) => {
        if (!urlParams.has(key)) {
          urlParams.set(key, value);
        }
      });
      
      const finalUrl = urlParams.toString() ? `${basePath}?${urlParams.toString()}` : basePath;
      navigate(finalUrl);
    }
    else {
      console.warn('リンクがありません');
    }
  };

  const handleConfirm = () => {
    setIsModalOpen(false);
    if (to) {
      // 現在のURLパラメータを取得
      const currentParams = new URLSearchParams(window.location.search);
      
      // toのURLに既存のパラメータがあるかチェック
      const [basePath, existingParams] = to.split('?');
      const urlParams = new URLSearchParams(existingParams || '');
      
      // 現在のパラメータを新しいURLパラメータにマージ（既存パラメータを優先）
      currentParams.forEach((value, key) => {
        if (!urlParams.has(key)) {
          urlParams.set(key, value);
        }
      });
      
      const finalUrl = urlParams.toString() ? `${basePath}?${urlParams.toString()}` : basePath;
      navigate(finalUrl);
    }
  };

  return (
    <div className={styles.layout}>
      <div className={styles.flex}>
        <div className={styles.labelFlex}>
          {firstcollectionhandle !== 'suits_campaign' && (
            <span className={`${global.label} ${global.reverse}`}>STEP{stepNumber}</span>
          )}
          <p className={styles.labelTitle}>{category}</p>
        </div>
        {category === '未設定' ? null : (
          <button onClick={handleClick} className={styles.changeButton}>
            変更する
          </button>
        )}
      </div>
      <AlertModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onConfirm={handleConfirm} />
    </div>
  );
};